import sortBy from 'lodash.sortby';

import { ValidationErrorsMessage } from '../../../../../../common/types';

const sortValidationErrorMessages = (
  validationResults: ValidationErrorsMessage[],
): ValidationErrorsMessage[] => sortBy(validationResults, ['type', 'validationType']);

export default sortValidationErrorMessages;
